import "./PublishConfirmation.scss";
import { Button, Text } from "@mantine/core";

interface PublishConfirmationProps {
  closeModal: () => void;
  onPublish: () => void;
}

const PublishConfirmation = ({
  closeModal,
  onPublish,
}: PublishConfirmationProps) => {
  return (
    <div className="publish-confirmation">
      <Text>
        You are about to publish a new version of this engagement letter.
      </Text>

      <div className="publish-confirmation-notes">
        <div className="publish-confirmation-notes-item">
          <Text fw={600} c={"#0077CC"}>
            Important note
          </Text>
          <Text>
            The updated engagement letter will not affect clients who have
            already signed or viewed the previous version.
          </Text>
        </div>
        <div className="publish-confirmation-notes-item">
          <Text fw={600} c={"#0077CC"}>
            Who will see it?
          </Text>
          <Text>
            Only new clients or clients who have not yet seen the engagement
            letter will receive this updated version
          </Text>
        </div>
      </div>

      <Text size={"sm"}>
        By proceeding, you acknowledge that SmartWiz is not liable for the
        content or use of this engagement letter.
      </Text>

      <div className="publish-confirmation-buttons">
        <Button
          variant="outline"
          className="cancel"
          color="#0077CC"
          radius={"md"}
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button color="#0077CC" radius={"md"} onClick={onPublish}>
          Publish
        </Button>
      </div>
    </div>
  );
};

export default PublishConfirmation;
